import React, { Fragment } from "react";
import PropTypes from "prop-types";
import {
  useTable,
  useGlobalFilter,
  useAsyncDebounce,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
} from "react-table";
import { Table, Row, Col, Button, Input } from "reactstrap";
import { DefaultColumnFilter } from "./filters";

const TableContainer = ({
  columns,
  data = [],
  isPagination,
  customPageSize,
  className,
  tableClassName,
  theadClassName,
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: { pageIndex: 0, pageSize: customPageSize },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination
  );

  return (
    <Fragment>
      {isPagination && (
        <Row className="mb-2">
          <Col md={2}>
            <select
              className="form-select"
              value={pageSize}
              onChange={(e) => setPageSize(Number(e.target.value))}
            >
              {[10, 20, 30, 40, 50].map((size) => (
                <option key={size} value={size}>
                  Show {size}
                </option>
              ))}
            </select>
          </Col>
        </Row>
      )}

      <div className="table-responsive ">
        <Table {...getTableProps()} className={tableClassName} >
          <thead className={theadClassName}>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
                {headerGroup.headers.map((column) => (
                  <th
                    className="py-4 px-3"
                    key={column.id}
                    {...column.getHeaderProps(column.getSortByToggleProps())} 
                    style={{ cursor: "pointer" }} 
                  >
                    {column.render("Header")}
                    <span
                    style={{
                      fontSize: "8px",
                      marginLeft: "5px", 
                      verticalAlign: "middle", 
                      background: "transparent", 
                      color: "inherit", 
                    }}
                  >
                    {column.isSorted
                      ? column.isSortedDesc
                        ? "▼" 
                        : "▲" 
                      : ""}
                  </span>
                  
                  
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} key={row.id}>
                  {row.cells.map((cell) => (
                    <td className="py-3 px-3" {...cell.getCellProps()} key={cell.id}>
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>

      {isPagination && (
        <Row className="justify-content-end align-items-center mt-2">
          <Col>
            <Button
              color="primary"
              onClick={() => gotoPage(0)}
              disabled={!canPreviousPage}
            >
              {"<<"}
            </Button>
            <Button
              color="primary"
              onClick={previousPage}
              disabled={!canPreviousPage}
            >
              {"<"}
            </Button>
            <span>
              Page {pageIndex + 1} of {pageOptions.length}
            </span>
            <Button
              color="primary"
              onClick={nextPage}
              disabled={!canNextPage}
            >
              {">"}
            </Button>
            <Button
              color="primary"
              onClick={() => gotoPage(pageOptions.length - 1)}
              disabled={!canNextPage}
            >
              {">>"}
            </Button>
          </Col>
        </Row>
      )}
    </Fragment>
  );
};

TableContainer.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  isPagination: PropTypes.bool,
  customPageSize: PropTypes.number,
  className: PropTypes.string,
  tableClassName: PropTypes.string,
  theadClassName: PropTypes.string,
};

export default TableContainer;
